import { CreditScoreGraph } from "shared/app/CreditScoreGraph";
import { Section } from "views/applications-id-report/components/Section";

interface CreditScoreProps {
  score: number;
  isNoHit: boolean;
}

export const CreditScore = ({ score, isNoHit }: CreditScoreProps) => {
  if (isNoHit)
    return (
      <Section sectionTitle="Credit score (Vantage Score 4)" maxWidth="none">
        <p className="text-base font-medium text-content-300">
          No data available
        </p>
      </Section>
    );

  return (
    <Section sectionTitle="Credit score (Vantage Score 4)" maxWidth="none">
      <p className="mb-1 text-sm font-normal text-content-1000">Credit score</p>
      <p className="mb-8 text-3xl font-bold text-content-1000">
        {score || "N/A"}
      </p>
      <CreditScoreGraph score={score} tooltipSize="L" />
    </Section>
  );
};
